export const getFirstFlowId = state => state.firstFlows.firstFlow.id;
export const getFirstFlowData = state => state.firstFlows.firstFlow;
export const firstFlowIsFetching = state => state.firstFlows.loading;